<template>
    <div>
        <loading v-show="loading"></loading>

        <booking-statistic is-prev="true" :zoneId="zone" floorId="" filter="months" :from="from" :to="to" :show-input="false"></booking-statistic>

    </div>
</template>

<script>

import ChartLine from "../components/Chart/ChartLine.vue"
import HourlyAttendanceStatistic from "../components/HourlyAttendanceStatistic.vue";
import BookingStatistic from "../components/BookingStatistic.vue"
import Headline from "../components/UI/Headline.vue"
import ButtonSecondary from "../components/UI/ButtonSecondary.vue"
import ButtonPrimary from "../components/UI/ButtonPrimary.vue"
import SelectMenu from "../components/UI/SelectMenu.vue"
import Modal from "../components/Modal.vue";
import InputText from "../components/UI/InputText.vue";
import Loading from "../components/UI/Loading.vue";
import moment from "moment";

export default {
    name: "StatisticReport",
    components: {
        ChartLine,
        HourlyAttendanceStatistic,
        BookingStatistic,
        Headline,
        ButtonSecondary,
        SelectMenu,
        Modal,
        ButtonPrimary,
        InputText,
        Loading,
    },

    props: ['zone','from','to'],

    data: () => ({
        loading: false,
        email: "",
        showModal: false,
        rooms: [],
        zones: [],
        floors: [],
    }),

    mounted() {
        this.load();
    },

    watch: {},

    computed: {
        textRooms() {
            return ['Alle'].concat(this.rooms.map(p => p.name));
        },
        valuesRooms() {
            return [null].concat(this.rooms.map(p => p.id));
        },
        textFloors() {
            return ['Alle'].concat(this.floors.map(p => p.name));
        },
        valuesFloors() {
            return [null].concat(this.floors.map(p => p.id));
        },
        textZones() {
            return ['Alle'].concat(this.zones.map(p => p.name));
        },
        valuesZones() {
            return [null].concat(this.zones.map(p => p.id));
        },
    },

    methods: {
        load() {
            this.loading = true;
            this.$http.get('/admin/desks').then(response => {
                this.rooms = response.data.rooms;
                this.floors = response.data.floors;
                this.zones = response.data.groups;
                this.loading = false;
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            });
        },
    }
}
</script>

